
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[productId]/[productName]",
      function () {
        return require("private-next-pages/products/[productId]/[productName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[productId]/[productName]"])
      });
    }
  